import { errorTostHandler } from "helper/ErrorTostHandler";
import {
  FORGOT_PASSWORD,
  GET_REGISTER_SECURITY_QUESTION,
  GET_USER_SECURITY_QUESTION,
  LOGIN,
  SIGNUP,
  UPDATE_PASSWORD,
} from "helper/url_helper";
import { toast } from "react-toastify";
import { axiosAccount } from "services/api";
import { get } from "services/cookies";
import { remove } from "services/localStorage";
import Track from "services/track";
import { fetchUserProfile, handleIsAuth, handleSetToken } from "store/actions";
import { isOrg } from "utils";
import {
  SET_ERROR,
  SET_LOADING,
  SET_SECURITY_QUESTION,
  SET_SECURITY_QUESTION_LOADING,
  SET_SUCCESS,
} from "./actionTypes";

const removeStorageLoginData = () => {
  remove("redirect_url");
  remove("site_id");
  remove("client_id");
};

export const handleLogin = (
  data,
  navigate,
  redirectUrl,
  redirectToDifferentSite
) => {
  return async dispatch => {
    try {
      dispatch(handleLoading(true));
      const res = await axiosAccount.post(LOGIN, {
        ...data,
        affiliate_visit_id: get("affiliate_visit_id") || 0,
      });
      if (res.data?.data) {
        dispatch(handleSuccess(res.data.message));
        if (data.isSSO && res.data?.data?.temptoken) {
          if (!!redirectToDifferentSite) {
            let appendWith = "?";
            if (redirectToDifferentSite.indexOf("?") !== -1) appendWith = "&";
            removeStorageLoginData();
            window.location.replace(
              `${redirectToDifferentSite}${appendWith}code=${res.data.data.temptoken}`
            );
            return;
          }
          return;
        }

        if (res.data.data?.user && res.data.data?.token) {
          dispatch(handleSetToken(res.data.data.token));

          if (
            [
              process.env.REACT_APP_FREE_TRIAL_SITE_URL.trim(),
              process.env.REACT_APP_CURRICULUM_SITE_URL.trim(),
            ]?.includes(redirectToDifferentSite)
          ) {
            window.location.replace(res.data?.data?.redirect_url);
            return;
          }
          if (!!redirectToDifferentSite) {
            removeStorageLoginData();
            window.location.replace(`${redirectToDifferentSite}`);
          } else if (
            !!res.data?.data?.redirect_url &&
            process.env.REACT_APP_FREE_TRIAL_SITE_URL.trim().includes(
              res.data?.data?.redirect_url.trim()
            ) &&
            !!!redirectUrl
          ) {
            window.location.replace(res.data?.data?.redirect_url);
          } else {
            if (!!redirectUrl && redirectUrl !== "/") {
              dispatch(handleIsAuth(true));
              dispatch(fetchUserProfile());
              navigate(redirectUrl);
            } else {
              window.location.replace(
                process.env.REACT_APP_CURRICULUM_SITE_URL
              );
            }
          }
        }
      }
      dispatch(handleLoading(false));
    } catch (err) {
      dispatch(handleError(err?.response?.data?.message || err.message));
      dispatch(handleLoading(false));
    }
  };
};

export const handleRegisterSecurityQuestion = () => {
  return async dispatch => {
    try {
      dispatch(handleSecurityQuestionLoading(true));
      const res = await axiosAccount.get(GET_REGISTER_SECURITY_QUESTION);
      if (res?.data?.data) {
        dispatch(handleSecurityQuestion(res.data.data));
      }
      dispatch(handleSecurityQuestionLoading(false));
    } catch (err) {
      errorTostHandler(err, 50);
      dispatch(handleSecurityQuestionLoading(false));
    }
  };
};

export const handleSignUp = (
  data,
  navigate,
  redirectUrl,
  redirectToDifferentSite,
  isVBSSignUp,
  isFreeTrialOrHubOrSlidrSignUp,
  content
) => {
  return async dispatch => {
    try {
      dispatch(handleLoading(true));
      const res = await axiosAccount.post(SIGNUP, {
        ...data,
        affiliate_visit_id: get("affiliate_visit_id") || 0,
      });
      const tracking = isOrg && (isVBSSignUp || isFreeTrialOrHubOrSlidrSignUp);
      const redirectFunc = () => {
        window.location.replace(process.env.REACT_APP_CURRICULUM_SITE_URL);
      };
      if (res.status) {
        dispatch(handleLoading(false));
        if (tracking) {
          Track.signUp(isVBSSignUp, isFreeTrialOrHubOrSlidrSignUp);
        }
        if (res.data?.data?.user_data?.is_user_exist === 1) {
          dispatch(handleError(res.data.message));
          return;
        } else {
          dispatch(handleSuccess(res.data.message));
        }
        // if (!!res.data?.data?.redirect_url) {
        if (!!content && !!!redirectToDifferentSite) {
          window.location.replace(content);
          return;
        }
        // else {
        //   window.location.replace(res.data?.data?.redirect_url);
        //   return;
        // }
        // }
        if (res.data.data?.user && res.data.data?.token) {
          toast.success(res.data.message);
          dispatch(handleSetToken(res.data.data.token));
          // dispatch(setToken(res.data.data.token));
          if (!!redirectToDifferentSite) {
            removeStorageLoginData();
            window.location.replace(`${redirectToDifferentSite}`);
          } else {
            if (!!redirectUrl && redirectUrl !== "/") {
              dispatch(handleIsAuth(true));
              dispatch(fetchUserProfile());
              navigate(redirectUrl);
            } else if (tracking) setTimeout(redirectFunc, 2000);
            else redirectFunc();
          }
        }
      }
    } catch (err) {
      dispatch(handleError(err.response?.data?.message || err.message));
      dispatch(handleLoading(false));
    }
  };
};

export const handleForgotPassword = ({ values, navigate, pathname }) => {
  return async dispatch => {
    try {
      dispatch(handleLoading(true));
      const res = await axiosAccount.post(FORGOT_PASSWORD, values);
      if (res.status && res.data) {
        if (pathname.toLowerCase() === "forgot-password-security-question") {
          dispatch(handleError("Security Question Verification Failed"));
        } else {
          dispatch(handleSuccess(res.data.message));
        }
        if (values.email) {
          setTimeout(() => {
            navigate(
              "/reset-password-otp?email=" +
                values.email +
                "&redirect_url=" +
                values.redirect_url
            );
          }, 2000);
        } else {
          setTimeout(() => {
            navigate(
              "/reset-password-security-question?email=" +
                values.email +
                "&redirect_url=" +
                values.redirect_url
            );
          }, 2000);
        }
      }
      dispatch(handleLoading(false));
    } catch (err) {
      dispatch(handleError(err.response?.data?.message || err.message));
      dispatch(handleLoading(false));
    }
  };
};

export const handleResetPassword = (data, cb) => async dispatch => {
  try {
    dispatch(handleLoading(true));
    const res = await axiosAccount.post(UPDATE_PASSWORD, data);
    if (res.status) {
      toast.success(res.data.message);
      dispatch(handleLoading(false));
      if (res.data.data?.token) {
        if (!!cb) cb();

        // dispatch(fetchProfile());
        // dispatch(setAuthData());
      }
    }
  } catch (err) {
    dispatch(handleError(err.response?.data?.message || err.message));
    dispatch(handleLoading(false));
  }
};

export const fetchSecurityQuestion = (data, cb) => {
  return async dispatch => {
    try {
      dispatch(handleLoading(true));
      const res = await axiosAccount.post(GET_USER_SECURITY_QUESTION, data);
      if (res.data) {
        dispatch(handleSecurityQuestion(res.data.data));
        cb(res.data.data.length);
      }
      dispatch(handleLoading(false));
    } catch (err) {
      errorTostHandler(err, 51);
      dispatch(handleLoading(false));
    }
  };
};

export const handleLoading = data => ({
  type: SET_LOADING,
  payload: data,
});

export const handleSuccess = data => ({
  type: SET_SUCCESS,
  payload: data,
});

export const handleError = data => ({
  type: SET_ERROR,
  payload: data,
});

export const handleSecurityQuestionLoading = data => ({
  type: SET_SECURITY_QUESTION_LOADING,
  payload: data,
});

export const handleSecurityQuestion = data => ({
  type: SET_SECURITY_QUESTION,
  payload: data,
});
